export default __webpack_public_path__ + "static/media/spol.4a308b18.jpg";